import { useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { v4 as uuidV4 } from 'uuid';

import TellyMarch from '../../../../images/telly-march.svg';
import { CreateSession } from '../../../../types/working-model';
import { createNewSession } from '../../../../store/actions/admin/create-event';
import "react-datepicker/dist/react-datepicker.css";
import Icon, { COLORS, ICONS } from '../../../general-ui/icon';
import SessionModal from '../session/session-modal';


export default function Agenda(): JSX.Element {
	const dispatch = useDispatch();

	const [addingSession, setAddingSession] = useState(false);
	const [sessionTipClass, setSessionTipClass] = useState("show");

	function closeSessionTip() {
		setSessionTipClass('hide');
	}

	function addSession() {
		setAddingSession(true);
	}

	function createSession(session: CreateSession) {
		//if the user didn't pick a language, they get english
		if (session.languages.length === 0) {
			session.languages = ['en'];
			session.default_language = 'en';
		}

		//if there's no default language, make it english if it exists, otherwise pick the first non-english language
		if (!session.default_language) {
			if (session.languages.includes('en')) {
				session.default_language = 'en';
			} else {
				session.default_language = session.languages[0];
			}
		}
		session.uid = uuidV4();
		dispatch(createNewSession(session));
		setAddingSession(false);
		closeSessionTip();
		return Promise.resolve();
	}

	function handleCloseModal() {
		setAddingSession(false);
	}

	return (
		<div className="agenda-container">
			<div className={classNames("session-tip", sessionTipClass)}>
				<button className='no-style close' onClick={closeSessionTip}>
					<Icon name={ICONS.CLOSE} color={COLORS.DEFAULT_GRAY} size={16} />
				</button>
				<div className="session-tip-text">
					<h5>What is a Session?</h5>
					<p>Session is a part of event that covers one specific topic. If you have planned more than one presentation/topics/etc. it is better to create an agenda so your participants could get an idea of what to expect.</p>
				</div>
				<img src={TellyMarch} alt="Telly Marching" />
			</div>

			<button className='add-session' onClick={addSession}>
				<Icon name={ICONS.ADD} color={COLORS.CYAN} size={16} /> Add Session
			</button>

			<SessionModal
				addingSession={addingSession}
				closeModal={handleCloseModal}
				createSession={createSession}
			/>
		</div>
	);
}
